/**
 * Soodam first-order discount.
 *
 * The Klaviyo-gated trigger opens the signup form, then silently applies the
 * discount code after a successful submission.
 */

const TRIGGER = '[data-soodam-first-order-trigger]';

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target.closest(TRIGGER) : null;
  if (!(target instanceof HTMLElement)) return;

  // The cart drawer is a showModal() dialog — top layer — so the Klaviyo
  // popup can never stack above it. Close it before opening the form
  // (SOO-29: the trigger also lives in the drawer's summary). Go through the
  // component's close(), not dialog.close(), so Horizon's cleanup (scroll
  // lock, mobile history state) runs — same pattern the drawer itself uses
  // for the installments CTA.
  const drawer = document.querySelector('cart-drawer-component');
  if (drawer?.querySelector('dialog[open]')) drawer.close();

  const formId = target.dataset.klaviyoFormId?.trim();
  if (formId) {
    event.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
    return;
  }

  const fallbackUrl = target.dataset.fallbackUrl?.trim();
  if (fallbackUrl) {
    event.preventDefault();
    window.location.href = fallbackUrl;
  }
  // No form ID and no fallback: rely on Klaviyo's own click-trigger bound to
  // the trigger selector. Do nothing here so we do not fight it.
});

let discountApplied = false;

window.addEventListener('klaviyoForms', (event) => {
  if (event.detail?.type !== 'submit' || discountApplied) return;

  const trigger = document.querySelector(TRIGGER);
  if (!(trigger instanceof HTMLElement)) return;

  const code = trigger.dataset.discountCode?.trim();
  if (!code) return;

  const formId = trigger.dataset.klaviyoFormId?.trim();
  const submittedFormId = event.detail.formId;
  if (formId && submittedFormId && formId !== submittedFormId) return;

  // Shopify's silent /discount/:code endpoint sets the discount session cookie
  // without navigation, so the code carries into checkout. Klaviyo can emit
  // repeated submit events, so guard the request once per page load.
  discountApplied = true;
  fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(() => {});
});
